<footer *ngIf="false" class="footer">
  <div class="container-fluid">
    <span class="text-muted">Version: {{version}}</span>
  </div>
</footer>

<footer class="footer">
  <div class="footer__left">
    <p>¿Tienes dudas? Escríbenos al área de Soporte Operacional:</p>
    <p class="link">SoporteOperacionaldeServiciosComerciales@sodimac.cl</p>
    <p>O levanta un ticket en la Mesa de Ayuda +56223859193</p>
  </div>

  <img class="footer__center-logo" src="./../../../assets/images-carousel/Logo-footer.png" alt="">

  <div class="footer__right">
    <!-- <a href="http://www.sodimac.cl" target="_blank">Ir a sodimac.cl</a> -->
    <a>.</a>
    <p>Servicios hogar, lo hacemos por ti</p>
    <p><span>® 2021 Sodimac S. A. | Version: {{ version }}</span></p>
  </div>
</footer>
